import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import React, { ReactElement, useContext } from 'react';

import { DialogContext } from '../../../dialogs/DialogProvider/DialogProvider';
import { useTranslation } from '../../../redux/translations/hook';
import { DF } from '../DialogFactory';
import messages from './messages';
import useStyles from './styles';

export interface INotificationDialogProps {
    content?: string | ReactElement;
}

const NotificationDialog: React.FC<INotificationDialogProps> = ({ content }) => {
    const classes = useStyles();
    const { toggleDialog } = useContext(DialogContext);

    // translations
    const transContent = useTranslation({ ...messages.content });
    const transBtnClose = useTranslation({ ...messages.btnClose });

    return (
        <>
            <DialogContent dividers className={classes.dialogContent}>
                <Typography variant="body1">{content ? content : transContent}</Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => toggleDialog(DF.NOTIFICATION_DIALOG)}
                >
                    {transBtnClose}
                </Button>
            </DialogActions>
        </>
    );
};

export default NotificationDialog;
